<template>
  <div class="price">
    <div
        class="banner"
        :style="{
        backgroundImage:
          'url(' + require('../assets/img/price/产品方案BG.jpg') + ')',
      }"
    >
      <div class="title">选择最适合您的购买方案</div>
      <div class="detail">电商业务/零售业务/全渠道业务/量身定制</div>
    </div>
    <!--    <div-->
    <!--        class="choes_bug"-->
    <!--        :style="{-->
    <!--        backgroundImage:-->
    <!--          'url(' + require('../assets/img/price/产品方案BG.jpg') + ')',-->
    <!--      }"-->
    <!--    >-->
    <!--      <div class="text">选择最适合您的购买方案</div>-->
    <!--      <div class="desc">电商业务/零售业务/全渠道业务/量身定制</div>-->
    <!--    </div>-->
    <div class="version">
      <div
          class="version_item"
          v-for="(item, i) in version"
          :key="i"
      >
        <div class="item_img">
          <img :src="item.img" :alt="item.title" />
        </div>
        <div class="item_text">
          <div class="tag">{{ item.tag }}</div>
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.detail }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      version: [
        {
          tag: '方案一',
          title: '电商业务',
          img: require('../assets/img/price/v1.jpg'),
          detail: '适合电商业务企业，以平台店铺维度结合上下游库存、订单、商品、销量、价格、时间等经营视角观察分析决策。',
        },
        {
          tag: '方案二',
          title: '零售业务',
          img: require('../assets/img/price/v2.jpg'),
          detail: '适合线下门店、渠道分销业务企业，以门店维度结合上下游库存、订单、商品、销量、价格、时间等经营视角观察分析决策。',
        },
        {
          tag: '方案三',
          title: '全渠道业务',
          img: require('../assets/img/price/v3.jpg'),
          detail: '适合线上线下全渠道业务企业，以线上平台店铺、线下门店维度结合上下游库存、订单、商品、销量、价格、时间等经营视角观察分析决策。',
        },
        {
          tag: '方案四',
          title: '量身定制',
          img: require('../assets/img/price/v4.jpg'),
          detail: '适合业务多元性、管理多维度、数据运算力庞大、数据源获取多方式等多元素经营体企业集团定制化BI运营。',
        },
      ],
    };
  },
  methods: {
    buy() {
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
@import '../assets/font/iconfont.css';

@media screen and (min-width: 1200px) {
  .price {
    .banner {
      background-size: cover;
      height: 200px;
      color: rgba(255, 255, 255, 0.9);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .title {
        font-size: 32px;
        margin-bottom: 22px;
      }

      .detail {
        opacity: 0.7;
        font-size: 18px;
      }
    }

    .version {
      width: 1200px;
      margin: 0 auto;
      padding-bottom: 60px;

      .version_item {
        display: flex;
        background: #F8F8F8;
        margin-top: 52px;
        border-radius: 10px;
        overflow: hidden;

        &:nth-child(2n+1) {
          flex-direction: row-reverse;

        }

        .item_img {
          width: 600px;
          height: 380px;
          flex-shrink: 0;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
          }
        }

        .item_text {
          flex: 1;
          padding: 50px 60px;
          color: #333;

          .title {
            margin-bottom: 30px;
            font-weight: bold;
            font-size: 28px;
            line-height: 1;
            color: #333333;
          }

          .text {
            width: 388px;
            font-size: 16px;
            color: #666666;
            line-height: 40px;
            text-align: justify;
          }

          .tag {
            margin-bottom: 18px;
            width: 76px;
            height: 28px;
            background: linear-gradient(270deg, #44A6C6, #0167F8);
            border-radius: 10px 0 10px 0;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-weight: 600;
            color: #FFFFFF;
          }
        }
      }
    }
  }

}

@media screen and (max-width: 1200px) {
  .price {
    .banner {
      background-size: cover;
      height: 2rem;
      color: rgba(255, 255, 255, 0.9);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .title {
        font-size: 0.32rem;
        margin-bottom: 0.22rem;
      }

      .detail {
        opacity: 0.7;
        font-size: 0.18rem;
      }
    }

    .version {
      padding-bottom: 1rem;
      display: flex;
      justify-content: space-between;
      margin: 0 0.32rem;
      flex-wrap: wrap;


      .version_item {
        background: #F8F8F8;
        border-radius: 0.2rem;
        overflow: hidden;

        width: 3.3rem;
        min-height: 6rem;
        box-sizing: border-box;
        margin-top: 0.3rem;

        .item_img {
          height: 40%;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
          }
        }

        .item_text {
          padding: 0.2rem;
          color: #333;

          .title {
            margin-bottom: 0.2rem;
            font-weight: bold;
            font-size: 0.3rem;
            line-height: 1;
            color: #333333;
          }

          .text {
            font-size: 0.24rem;
            color: #666666;
            line-height: 1.4;
            text-align: justify;
          }

          .tag {
            margin-bottom: 0.2rem;
            width: 1.2rem;
            height: 0.45rem;
            background: linear-gradient(270deg, #44A6C6, #0167F8);
            border-radius: 10px 0 10px 0;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.2rem;
            font-weight: 600;
            color: #FFFFFF;
          }
        }
      }
    }
  }

}
</style>
